<!--
 @description 数据字典配置页
 @date 2018/11/22
-->
<template>
  <div class="dataDicProperty__content">
    <g-back :history="history"></g-back>
    <div style="margin-bottom: 16px;">
      <el-button type="primary" 
        @click="addProperty" 
        v-g-rac="gRac('dataDicProperty_add')" 
        v-text="$t('common.add')"></el-button>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="property"
        :label="$t('dataDictionary.propertyTable.property')">
      </el-table-column>
      <el-table-column
        prop="propertyName"
        :label="$t('dataDictionary.propertyTable.propertyName')">
      </el-table-column>
      <el-table-column
        prop="type"
        :label="$t('dataDictionary.propertyTable.type')">
      </el-table-column>
      <el-table-column
        prop="enumeration"
        :label="$t('dataDictionary.propertyTable.enumeration')">
      </el-table-column>
      <el-table-column
        prop="require"
        :label="$t('dataDictionary.propertyTable.require')">
      </el-table-column>
      <el-table-column
        prop="only"
        :label="$t('dataDictionary.propertyTable.only')">
      </el-table-column>
      <el-table-column
        prop="onlyRead"
        :label="$t('dataDictionary.propertyTable.onlyRead')">
      </el-table-column>
      <el-table-column
        fixed="right"
        :label="$t('dataDictionary.operate')">
        <template slot-scope="scope">
          <el-button 
            type="text" 
            size="small" 
            v-text="$t('common.delete')" 
            @click="deleteProperty(scope.row)"
            v-g-rac="gRac('dataDicProperty_delete')"></el-button>
          <el-button 
            type="text" 
            size="small" 
            v-text="$t('common.edit')" 
            @click="editProperty(scope.row)"
            v-g-rac="gRac('dataDicProperty_amend')"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <dialog-form
      id="propertyDiaForm"
      :title="propertyDiaTitle"
      :label-size="2"
      :visible.sync="dialogDiaVis" 
      :model="dialogForm"
      :input-data="dialogData"
      :rules="dialogFormRule"
      :confirm-fun="dialogConfirm">
    </dialog-form>
  </div>
</template>
  
<script>
  import dialogForm from '@/components/dialogForm'

  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import dataDictionaryBiz from '@/logic/cmdb/dataDictionaryBiz'
  import validateConfig from '@/utils/validate'
  export default {
    mixins: [rac, dic],
    data () {
      return {
        history: [],
        isEdit: false,
        tableData: [],
        select_valueType: {},
        propertyDiaTitle: this.$t('dataDictionary.addProperty'),
        dialogDiaVis: false,
        dialogForm: {
          property: '',
          propertyName: '',
          type: '',
          enumeration: '',
          checkList: []
        },
        dialogFormRule: {},
        dialogData: [],
        checkboxObj: {
          require: this.$t('dataDictionary.require'),
          only: this.$t('dataDictionary.only'),
          onlyRead: this.$t('dataDictionary.onlyRead')
        },
        selectId: ''
      }
    },
    components: {
      dialogForm
    },
    methods: {
      async waitValueType () {
        await this.dGetDictionaryByCode('vauleType')
        this.select_valueType = { ...this.dDictionary.vauleType }
        this.setDialogData()
        this.search()
      },
      setHisotry () {
        this.history = []
        this.history.push({
          name: this.$route.query.database,
          path: `/home/dataDictionary/dataDicConfig?id=${this.$route.query.id}&database=${this.$route.query.database}`
        }, {
          name: this.$route.query.tableName
        })
      },
      addProperty () {
        for (let i in this.dialogForm) {
          this.dialogForm[i] = ''
        }
        this.dialogForm.checkList = []
        this.isEdit = false
        this.dialogDiaVis = true
      },
      deleteProperty (deleteInfo) {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          dataDictionaryBiz.deleteTableProperty({
            id: deleteInfo.id,
            tableId: this.$route.query.tableId
          }).then(() => {
            this.handleSuccess()
            this.dialogDiaVis = false
          })
        }).catch(() => {})
      },
      editProperty (editInfo) {
        let editObj = { ...editInfo }
        this.selectId = editObj.id
        // 查找类型字典
        editObj.type = Object.keys(this.select_valueType)
          .filter(item => editObj.type === this.select_valueType[item])[0]
        editObj.checkList = []
        // 转换checkList
        let checkList = ['only', 'onlyRead', 'require']
        checkList.map(item => {
          if (editObj[item] === this.$t('dataDictionary.yes')) editObj.checkList.push(this.$t(`dataDictionary.${item}`))
        })
        this.dialogForm = editObj
        this.isEdit = true
        this.dialogDiaVis = true
      },
      setDialogData () {
        this.dialogData = [{
          label: this.$t('dataDictionary.property'),
          key: 'property'
        }, {
          label: this.$t('dataDictionary.name'),
          key: 'propertyName'
        }, {
          label: this.$t('dataDictionary.type'),
          key: 'type',
          type: 'select',
          select: this.select_valueType
        }, {
          label: this.$t('dataDictionary.enumeration'),
          key: 'enumeration'
        }, {
          key: 'checkList',
          type: 'checkboxGroup',
          select: this.checkboxObj
        }]
        this.dialogFormRule = {
          property: [{ ...validateConfig.common.notEmpty }],
          propertyName: [{ ...validateConfig.common.notEmpty }],
          type: [{ ...validateConfig.common.notEmpty }]
        }
      },
      search () {
        dataDictionaryBiz.getTableProperty({ id: this.$route.query.tableId }).then(data => {
          let arr = []
          data.map(item => {
            for (let i in item) {
              if (item[i] === false) {
                item[i] = this.$t('dataDictionary.no')
              } else if (item[i] === true) {
                item[i] = this.$t('dataDictionary.yes')
              } else if (i === 'type') {
                item[i] = this.select_valueType[item[i]]
              }
            }
            arr.push(item)
          })
          this.tableData = arr
        })
      },
      handleSuccess () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
        this.search()
      },
      dialogConfirm (formInfo) {
        let saveObj = { ...formInfo }
        // 转换checkList
        for (let i in this.checkboxObj) {
          saveObj[i] = !!(saveObj.checkList.filter(item => item === this.checkboxObj[i]).length > 0)
        }
        saveObj.tableId = this.$route.query.tableId
        saveObj.parentId = this.$route.query.id
        delete saveObj.checkList
        if (this.isEdit) {
          saveObj.id = this.selectId
          dataDictionaryBiz.updateProperty(saveObj).then(data => {
            this.handleSuccess()
            this.dialogDiaVis = false
          })
        } else {
          delete saveObj.id
          dataDictionaryBiz.saveTableProperty(saveObj).then(data => {
            this.handleSuccess()
            this.dialogDiaVis = false
          })
        }
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'dataDicProperty' && from.name === 'dataDicConfig') {
          this.setHisotry()
          this.waitValueType()
        }
      },
      isEdit (val) {
        this.propertyDiaTitle = val ? this.$t('dataDictionary.amendProperty')
          : this.$t('dataDictionary.addProperty')
      }
    },
    mounted () {
      this.setHisotry()
      this.waitValueType()
    }
  }
</script>

<style scoped>
</style>